import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15 5h1V3h-1a3.5 3.5 0 0 1-2.727-1.268L11.5.79l-.773.943A3.5 3.5 0 0 1 8 3a3.525 3.525 0 0 1-2.734-1.278L4.5.813l-.765.91A3.525 3.525 0 0 1 1 3H0v2h1a5.55 5.55 0 0 0 3.5-1.239A5.556 5.556 0 0 0 8 5.001a5.534 5.534 0 0 0 3.5-1.23c.99.8 2.227 1.234 3.5 1.23Zm1 5h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01 5.55 5.55 0 0 1-3.5 1.24H0V8h1a3.525 3.525 0 0 0 2.735-1.278l.764-.91.766.91a3.566 3.566 0 0 0 5.462.01l.773-.944.773.943A3.5 3.5 0 0 0 15 8h1v2Zm0 5h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01 5.55 5.55 0 0 1-3.5 1.24H0v-2h1a3.525 3.525 0 0 0 2.735-1.278l.764-.91.766.91a3.566 3.566 0 0 0 5.462.01l.773-.944.773.943A3.5 3.5 0 0 0 15 13h1v2Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructurePool16 = createIcon(IconComponent);